export default __webpack_public_path__ + "static/media/ic-delete.d960b140.svg";